module.exports = __webpack_public_path__ + "img/location-deny.2b9cef7f.png";